/**
 * Shared chrome and formatting for the mailing screens.
 *
 * Every screen renders the same sub-navigation and the same inline feedback
 * banner, so both live here rather than being copy-pasted seven times.
 */
define('mailingShell',[
  'module',
  'underscore'
], function (
  module,
  _
) {
  'use strict';

  var TABS = [
    { key: 'campaigns', route: 'mailing/campaigns', label: 'Campaigns' },
    { key: 'workflows', route: 'mailing/workflows', label: 'Workflows' },
    { key: 'templates', route: 'mailing/templates', label: 'Templates' },
    { key: 'segments', route: 'mailing/segments', label: 'Segments' },
    { key: 'subscribers', route: 'mailing/subscribers', label: 'Contacts' },
    { key: 'queue', route: 'mailing/queue', label: 'Outbox' },
    { key: 'settings', route: 'mailing/settings', label: 'Settings' }
  ];

  var Shell = {

    /**
     * Sub-navigation bar. `active` is one of the tab keys; `actionsHtml` is
     * dropped on the right of the bar for screen-specific buttons.
     */
    navHtml: function (active, actionsHtml) {
      var tabs = _.map(TABS, function (tab) {
        return '<a class="mlg-tab' + (tab.key === active ? ' active' : '') +
          '" href="#' + tab.route + '">' + _.escape(tab.label) + '</a>';
      }).join('');
      return '<div class="mlg-nav">' +
        '<div class="mlg-tabs">' + tabs + '</div>' +
        '<div class="mlg-nav-actions">' + (actionsHtml || '') + '</div>' +
        '</div>' +
        '<div class="mlg-banner" style="display:none"></div>';
    },

    /** Inline feedback. `type` is 'ok' or 'error'; both auto-dismiss. */
    banner: function ($root, message, type) {
      var $banner = $root.find('.mlg-banner').first();
      if (!$banner.length) { return; }
      $banner
        .removeClass('ok error')
        .addClass(type === 'error' ? 'error' : 'ok')
        .text(message)
        .show();
      if ($banner.data('mlgTimer')) {
        window.clearTimeout($banner.data('mlgTimer'));
      }
      $banner.data('mlgTimer', window.setTimeout(function () { $banner.fadeOut(200); },
        type === 'error' ? 8000 : 4000));
    },

    /** Day-first date, the format used across this dashboard. */
    formatDate: function (value, withTime) {
      if (!value) { return ''; }
      var date = new Date(value);
      if (isNaN(date.getTime())) { return ''; }
      var options = { day: '2-digit', month: '2-digit', year: 'numeric' };
      if (withTime) {
        options.hour = '2-digit';
        options.minute = '2-digit';
      }
      return date.toLocaleString('fr-BE', options);
    },

    /** Thousands separator without locale APIs (the jshint target is es3). */
    formatNumber: function (value) {
      var rounded = Math.round(Number(value) || 0);
      return String(rounded).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },

    formatMoney: function (value) {
      var amount = Number(value) || 0;
      return '€ ' + Shell.formatNumber(amount);
    },

    formatPercent: function (ratio) {
      return (Math.round((Number(ratio) || 0) * 1000) / 10) + '%';
    },

    /** Turns a backend CONSTANT into a readable label. */
    prettyCase: function (value) {
      if (!value) { return ''; }
      return String(value).replace(/_/g, ' ').toLowerCase()
        .replace(/\b([a-z])/g, function (match, character) { return character.toUpperCase(); });
    },

    /** Datetime-local input value ("2026-08-17T14:30") from a Date. */
    toLocalInputValue: function (date) {
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()) +
        'T' + pad(date.getHours()) + ':' + pad(date.getMinutes());
    },

    /** Small "no rows yet" block, so empty states look the same everywhere. */
    emptyHtml: function (message) {
      return '<div class="mlg-empty">' + _.escape(message) + '</div>';
    }
  };

  module.exports = Shell;
});

